function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es7.object.values.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.object.define-properties.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import WidgetTypeSelect from './widgetTypeSelect.vue';
import WidgetSizeSelect from './sizeSelect.vue';
import cloneDeep from 'lodash/cloneDeep';
import _get from 'lodash/get';
import TemplateTextField from './templateTextField.vue';
export default {
  name: 'WidgetMetaEditor',
  components: {
    WidgetTypeSelect: WidgetTypeSelect,
    WidgetSizeSelect: WidgetSizeSelect,
    TemplateTextField: TemplateTextField
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    dataSet: {
      type: Object,
      required: true
    },
    customParameters: {
      type: Object,
      required: true
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'color', 'inpFilled'])), {}, {
    twins: function twins() {
      if (_get(this.dataSet, 'error')) {
        return [];
      }
      return Object.values(_get(this, 'dataSet.data', {})).map(function (chartTypeDataArray) {
        return chartTypeDataArray.map(function (data) {
          return data.twin;
        }).flat();
      }).flat().filter(Boolean);
    },
    widgetTitle: {
      get: function get() {
        return _get(this.value, 'title');
      },
      set: function set(val) {
        var clone = cloneDeep(this.value);
        clone.title = val;
        this.$emit('input', clone);
      }
    },
    hideHeader: {
      get: function get() {
        return _get(this.value, 'hideHeader');
      },
      set: function set(val) {
        var clone = cloneDeep(this.value);
        clone.hideHeader = val;
        this.$emit('input', clone);
      }
    },
    floatHeader: {
      get: function get() {
        return _get(this.value, 'floatHeader');
      },
      set: function set(val) {
        var clone = cloneDeep(this.value);
        clone.floatHeader = val;
        this.$emit('input', clone);
      }
    },
    borderless: {
      get: function get() {
        return _get(this.value, 'borderless');
      },
      set: function set(val) {
        var clone = cloneDeep(this.value);
        clone.borderless = val;
        this.$emit('input', clone);
      }
    },
    minHeightPx: {
      get: function get() {
        return _get(this.value, 'minHeightPx', null);
      },
      set: function set(val) {
        if (val === undefined) {
          val = null;
        }
        if (val !== null) {
          val = Number(val);
          if (isNaN(val)) {
            val = null;
          }
        }
        var clone = cloneDeep(this.value);
        clone.minHeightPx = val;
        this.$emit('input', clone);
      }
    },
    widgetSize: {
      get: function get() {
        return _get(this.value, 'size');
      },
      set: function set(val) {
        var clone = cloneDeep(this.value);
        clone.size = val;
        this.$emit('input', clone);
      }
    },
    widgetType: {
      get: function get() {
        return _get(this.value, 'type');
      },
      set: function set(val) {
        var clone = cloneDeep(this.value);
        clone.type = val;
        if (val === 'chart') {
          clone.chartOptions = {
            stateIdentifiers: [],
            type: 'line'
          };
        }
        if (val === 'twin-table') {
          clone.twinTableOptions = {
            columns: [{
              property: 'twin.title',
              label: ''
            }]
          };
        }
        this.$emit('input', clone);
      }
    }
  })
};